module.exports = __webpack_public_path__ + "static/media/about1.e465575a.jpg";